import PropTypes from 'prop-types';
import { PDFViewer, Document, Page } from '@react-pdf/renderer';

import InvoiceHeader from './components/InvoiceHeader';
import InvoiceTitle from './components/InvoiceTitle';
import InvoiceDate from './components/InvoiceDate';
import InvoiceTo from './components/InvoiceTo';
import InvoiceFrom from './components/InvoiceFrom';
import InvoiceGreetings from './components/InvoiceGreetings';
import InvoiceDetailedTitle from './components/InvoiceDetailedTitle';
import InvoiceTotalAmount from './components/InvoiceTotalAmount';
import InvoiceDetailedAmount from './components/InvoiceDetailedAmount';
import InvoicePaymentMethod from './components/InvoicePaymentMethod';
import InvoiceRemarks from './components/InvoiceRemarks';
import InvoiceFooter from './components/InvoiceFooter';
import { styles } from './styles';
import logger from 'utils/logger';

const log = logger.createLogger('InvoiceEditorPreview');

const propTypes = {
  invoiceContent: PropTypes.object.isRequired,
  shouldShowPreview: PropTypes.bool.isRequired,
};

const DashboardBillingForReceivedTasksInvoiceEditorPreview = ({
  invoiceContent,
  shouldShowPreview,
}) => {
  const invoiceTitle = '';
  return shouldShowPreview ? (
    <PDFViewer width="100%" height="100%">
      <Document title={invoiceTitle}>
        <Page size="A4" style={styles.invoiceFirstPage} wrap={true}>
          <InvoiceHeader />
          <InvoiceTitle />
          <InvoiceDate invoiceDate={invoiceContent.invoiceDate} />
          <InvoiceTo
            invoiceTo={invoiceContent.invoiceTo}
            invoiceTo2={invoiceContent.invoiceTo2}
          />
          <InvoiceFrom invoiceFrom={invoiceContent.invoiceFrom} />
          <InvoiceGreetings />
          <InvoiceDetailedTitle
            invoiceDetailedTitle={invoiceContent.invoiceDetailedTitle}
          />
          <InvoiceTotalAmount
            invoiceTotalAmountIncludingTax={
              invoiceContent.invoiceTotalAmountIncludingTax
            }
          />
          <InvoiceDetailedAmount invoiceContent={invoiceContent} />
          <InvoicePaymentMethod
            invoicePaymentMethod={invoiceContent.invoicePaymentMethod}
          />
          <InvoiceRemarks invoiceRemarks={invoiceContent.invoiceRemarks} />
          <InvoiceFooter />
        </Page>
      </Document>
    </PDFViewer>
  ) : (
    <></>
  );
};

DashboardBillingForReceivedTasksInvoiceEditorPreview.propTypes = propTypes;

export default DashboardBillingForReceivedTasksInvoiceEditorPreview;
